import React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

interface ErrorMessageProps {
  message?: string;
  onRetry?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message = 'Đã xảy ra lỗi khi tải dữ liệu.',
  onRetry,
}) => (
  <Box sx={{ my: 2 }}>
    <Alert
      severity="error"
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry} aria-label="Thử lại tải dữ liệu">
            Thử lại
          </Button>
        ) : undefined
      }
    >
      {message}
    </Alert>
  </Box>
);
